import ShareButtons from '@kopapro/components/commons/shareButtons/shareButtons';

export default ShareButtons;
